import { createSlice } from "@reduxjs/toolkit";

// Create a slice for categories
const dealerSlice = createSlice({
  name: "dealer",
  initialState: {
    dealerItems: [],
    dealer: {},
    nonActiveDealer: [],
    loading: false,
    error: null,
  },
  reducers: {
    setDealerItems: (state, action) => {
      state.dealerItems = action.payload.data || [];
      state.loading = false;
    },
    setDealer: (state, action) => {
      state.dealer = action.payload.data || [];
      state.loading = false;
    },
    setNonApprovedDealerItems: (state, action) => {
      state.nonActiveDealer = action.payload.data || [];
      state.loading = false;
    },
  },
});

// Export the loading and error selectors if needed
export const selectDealerLoading = (state) => state.dealer.loading;
export const selectDealerError = (state) => state.dealer.error;
export const selectDealerItems = (state) => state.dealer.dealerItems;
export const selectDealer = (state) => state.dealer.dealer;
export const selectNonActiveDealers = (state) => state.dealer.nonActiveDealer;

// Export the reducer to include in the store
export const { setDealer, setDealerItems, setNonApprovedDealerItems } = dealerSlice.actions;
export default dealerSlice.reducer;
